import axios from "./axios-auth";

const getOrder = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getorder",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in getOrder api");
      });
  });

const updateOrderAddress = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateorderaddress",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in updateOrderAddress api");
      });
  });

const updateGiftCard = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updategiftcard",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in updateGiftCard api");
      });
  });

const updateOrderStatus = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateorderstatus",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in updateOrderStatus api");
      });
  });

const updateShipping = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateshippinginformation",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in updateShipping api");
      });
  });

const getCRMNotes = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcrmnotes",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in getCRMNotes api");
      });
  });

const getInvoices = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getinvoices",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in getInvoices api");
      });
  });

const addInvoice = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addinvoice",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in addInvoice api");
      });
  });

const deleteInvoice = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deleteinvoice",
      method: "DELETE",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in deleteInvoice api");
      });
  });

const updateAll = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateall",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in updateAll api");
      });
  });

const getCRMNote = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcrmnote",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in getCRMNote api");
      });
  });

const getExtraOrderInfo = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getextraorderinfo",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in getExtraOrderInfo api");
      });
  });

const addNote = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addnote",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in addNote api");
      });
  });

const updateNote = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updatenote",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        reject();
        console.log(err, "err in updateNote api");
      });
  });

export {
  getOrder,
  updateOrderAddress,
  updateGiftCard,
  updateOrderStatus,
  updateShipping,
  getCRMNotes,
  getInvoices,
  addInvoice,
  deleteInvoice,
  updateAll,
  getCRMNote,
  getExtraOrderInfo,
  addNote,
  updateNote,
};
